import React, { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { getCurrentUser, isAuthenticated } from "./auth-service";
import CustomLoader from "./components/common/custom-loader";
import { useAtomValue } from "jotai";
import { userAtom } from "./state";

const ProtectedRoute = ({ element: Component }) => {
  const [checkingUser, setCheckingUser] = useState(true);
  const [isAuthorized, setIsAuthorized] = useState(false);
  const user = useAtomValue(userAtom);

  // Need to wait until the user is re-hydrated from the local storage
  useEffect(() => {
    console.log("Protected route. Getting current user");
    const checkAuth = async () => {
      await getCurrentUser(); // Update user data if needed
      const authorized = await isAuthenticated();
      setIsAuthorized(authorized);
      setCheckingUser(false);
    };

    checkAuth();
  }, [user]);

  if (checkingUser) {
    return <CustomLoader />;
  }

  // Redirect to login if not authenticated
  if (!isAuthorized) {
    return <Navigate to="/login" replace />;
  }

  // Render the protected component if authorized
  return <Component />;
};

export default ProtectedRoute;
